import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./index.css";

const elemento = document.getElementById("root");
if (!elemento) throw new Error("#root nao encontrado");

createRoot(elemento).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
